import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { PageHero } from "../../components/site/PageHero";
import { CTABand } from "../../components/site/CTABand";
import { Stagger, StaggerItem } from "../../components/motion/Reveal";
import { SOLUTION_DETAILS } from "../../data/solutions";

export default function SolutionsIndex() {
  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased" data-testid="solutions-page">
      <SiteHeader />
      <PageHero
        crumb="Solutions"
        eyebrow="Solutions"
        title="Integrated systems,"
        titleAccent="engineered as one."
        description="Ten solution areas covering the complete technology fabric of a modern building or organisation — designed to work together, delivered by one accountable team."
      />
      <section className="py-16 sm:py-24">
        <div className="nx-wrap">
          <Stagger className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {SOLUTION_DETAILS.map((s, i) => (
              <StaggerItem key={s.slug}>
                <Link to={`/solutions/${s.slug}`} className="group flex h-full flex-col bg-nx-navy hover:bg-nx-navy2 p-7 sm:p-9 transition-colors duration-300" data-testid={`solution-card-${s.slug}`}>
                  <div className="flex items-start justify-between">
                    <span className="font-marcellus text-nx-gold/60 text-lg">{String(i + 1).padStart(2, "0")}</span>
                    <ArrowUpRight size={18} className="text-slate-600 group-hover:text-nx-goldlight group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <h2 className="font-marcellus text-xl sm:text-2xl text-white mt-6">{s.name}</h2>
                  <p className="text-sm text-slate-400 mt-3 leading-relaxed flex-1">{s.tagline}</p>
                  <span className="block mt-7 h-px w-8 bg-nx-gold/50 group-hover:w-full transition-all duration-500" />
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
      <CTABand />
      <SiteFooter />
    </div>
  );
}
